var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"login-content"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"logo"}),_c('router-view')],1)]),_c('footer',{staticClass:"footer-div"})])
}
var staticRenderFns = []

export { render, staticRenderFns }